import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/atlante';
export function PurchaseToast() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(recentBuyers[0]);
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    const show = () => {
      setBuyer(recentBuyers[Math.floor(Math.random() * recentBuyers.length)]);
      setVisible(true);
      hideTimer = setTimeout(() => setVisible(false), 5000);
    };
    const first = setTimeout(show, 3000);
    const interval = setInterval(show, 15000);
    return () => {
      clearTimeout(first);
      clearTimeout(hideTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-149" data-mp="f4np8mg3fdwn">
      {visible && <motion.div initial={{
      opacity: 0,
      x: 40,
      scale: 0.96
    }} animate={{
      opacity: 1,
      x: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      x: 40,
      scale: 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed right-2 top-2 z-50 w-[230px] sm:w-[250px]" role="status" aria-live="polite" data-id="element-150" data-mp="f3m39mxjh705">
          <div className="relative overflow-hidden rounded-lg border-2 border-green bg-white p-2 pr-6 shadow-2xl" data-id="element-151" data-mp="238h5zisnk64f">
            <span className="absolute inset-x-0 top-0 h-1 bg-gold" aria-hidden="true" data-id="element-152" data-mp="285hee0cz5kyp" />
            <button type="button" onClick={() => setVisible(false)} aria-label="Chiudi la notifica" className="absolute right-1 top-1.5 text-slate2 transition-colors duration-150 hover:text-navy" data-id="element-153" data-mp="1fhlaobozmssf">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-154" data-mp="1p8pmx3na3zjk" />
            </button>
            <div className="flex items-center gap-2" data-id="element-155" data-mp="rr916we3gnzq">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-green/15 text-green" data-id="element-156" data-mp="wqu5znfy3qkd">
                <CheckCircle2Icon className="h-4 w-4" aria-hidden="true" data-id="element-157" data-mp="2017wly4q4pye" />
              </span>
              <div className="leading-tight" data-id="element-158" data-mp="1v3pyz3w5px5p">
                <p className="text-[12px] font-extrabold text-navy" data-id="element-159" data-mp="1v0tzvc8kp2fo">
                  {buyer.name}
                </p>
                <p className="text-[10px] font-semibold text-slate2" data-id="element-160" data-mp="24spz4qmeaylh">
                  {buyer.location}
                </p>
                <p className="mt-0.5 text-[10.5px] font-bold text-green" data-id="element-161" data-mp="1h2n9si9v86qk">
                  ha appena acquistato l’ATLANTE™
                </p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}